import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BiWifiOff } from "react-icons/bi";

export default function useNetworkHook() {
    const [isOnline, setOnline] = useState(true)

    const {t} = useTranslation()

    const OfflineWarningToast = useCallback(() => {
        if(!isOnline) {
            return (
                <div className="luna-offline-toast">
                    <BiWifiOff /> <span>{t('globalAlert.noInternetConnection')}</span>
                </div>
            )
        }

        return '';
    },[isOnline])

    useEffect(() => {
        window.addEventListener("offline", () => {
            setOnline(false);
            document.querySelector('body').classList.add('network-off')
        });
        window.addEventListener("online", () => {
            setOnline(true);
            document.querySelector('body').classList.remove('network-off')
        });
    
        return () => {
          window.removeEventListener("offline", () => {
            document.querySelector('body').classList.add('network-off')
            setOnline(false);
          });
          window.removeEventListener("online", () => {
            document.querySelector('body').classList.remove('network-off')
            setOnline(true);
          });
        };
    }, []);

    return { isOnline, OfflineWarningToast };
}
